module.exports = __webpack_public_path__ + "images/poster/type_B_f74a84b6f18fd584f73363bcbd5406d4.jpg";